 
document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.style.setProperty(
    '--scrollbarwidth',
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );
}); 
 
 
 
 
 
 document.addEventListener('DOMContentLoaded', () => {
  const form      = document.querySelector('.contact__form');
  const submitBtn = document.querySelector('.contact__button');

  const firstName = form?.querySelector('.wac-first-name-contact');
  const lastName  = form?.querySelector('.wac-last-name');
  const email     = form?.querySelector('.wac-email-contact');
  const mobile    = form?.querySelector('.wac-mobile-contact');
  const country = form?.querySelector('.wac-country-contact');
  const message   = form?.querySelector('.wac-message-contact');

  if (
    !form ||
    !submitBtn ||
    !firstName ||
    !lastName ||
    !email ||
    !mobile ||
    !country ||
    !message
  ) return;

  const ERR = {
    firstName: 'firstNameError',
    lastName:  'lastNameError',
    email:     'emailError',
    mobile:    'mobileError',
    message:   'messageError'
  };

  // Local part: dot-separated atoms, so no leading, trailing or repeated dots.
  // Domain: each label starts and ends alphanumeric (hyphens allowed inside).
  // TLD: letters only, at least two.
  const EMAIL_REGEX  = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
  const EMAIL_MAX_LENGTH = 254;
  const MOBILE_REGEX = /^[0-9]{7,15}$/;

  /* ===============================
     Helpers
  =============================== */
  function clearError(input, id) {
    const el = input.parentNode.querySelector(`#${id}`);
    if (el) el.remove();
  }

  function showError(input, id, msg) {
    clearError(input, id);
    const div = document.createElement('div');
    div.id = id;
    div.className = 'validation-error';
    div.textContent = msg;
    input.parentNode.appendChild(div);
  }

  /* ===============================
     Validators
  =============================== */
 function validateFirstName(show) {
  const v = firstName.value.trim();
  let valid = true;

  if (!v) {
    if (show) showError(firstName, ERR.firstName, 'First name is required');
    valid = false;
  } else if (v.length < 3) {
    if (show) showError(firstName, ERR.firstName, 'Please enter at least 3 characters');
    valid = false;
  } else {
    clearError(firstName, ERR.firstName);
  }

  return valid;
}


  function validateLastName(show) {
    const v = lastName.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(lastName, ERR.lastName, 'Last name is required');
      valid = false;
    } else {
      clearError(lastName, ERR.lastName);
    }
    return valid;
  }

  function validateEmail(show) {
    const v = email.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(email, ERR.email, 'Email is required');
      valid = false;
    } else if (v.length > EMAIL_MAX_LENGTH) {
      if (show) showError(email, ERR.email, 'Email address is too long');
      valid = false;
    } else if (!EMAIL_REGEX.test(v)) {
      if (show) showError(email, ERR.email, 'Enter a valid email address');
      valid = false;
    } else {
      clearError(email, ERR.email);
    }
    return valid;
  }

  function validateMobile(show) {
    const v = mobile.value.replace(/\D/g, '');
    mobile.value = v;

    let valid = true;

    if (!v) {
      if (show) showError(mobile, ERR.mobile, 'Mobile number is required');
      valid = false;
    } else if (!MOBILE_REGEX.test(v)) {
      if (show) showError(mobile, ERR.mobile, 'Enter a valid mobile number');
      valid = false;
    } else {
      clearError(mobile, ERR.mobile);
    }
    return valid;
  }

  function validateCountry(show) {
  let valid = true;
  const value = country.value;

  // Shopify placeholder option
  if (!value || value === '---') {
    if (show) {
      showError(country, 'countryError', 'Please select a valid country');
    }
    valid = false;
  } else {
    clearError(country, 'countryError');
  }

  return valid;
}



  function validateMessage(show) {
    const v = message.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(message, ERR.message, 'Message is required');
      valid = false;
    } else {
      clearError(message, ERR.message);
    }
    return valid;
  }

  function validateForm(show) {
    let valid = true;
    valid = validateFirstName(show) && valid;
    valid = validateLastName(show)  && valid;
    valid = validateEmail(show)     && valid;
    valid = validateMobile(show)    && valid;
      valid = validateCountry(show)   && valid; // 👈 added
    valid = validateMessage(show)   && valid;
    return valid;
  }

  /* ===============================
     Live validation
  =============================== */
firstName.addEventListener('input', () => {
  firstName.value = firstName.value
    .replace(/[^a-zA-Z\s]/g, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s+/, '');

  validateFirstName(true);
});
lastName.addEventListener('input', () => {
  lastName.value = lastName.value
    .replace(/[^a-zA-Z\s]/g, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s+/, '');

  validateLastName(true);
});
// Only nag about format once the field has been left (or submit attempted).
// Until then a passing `validateEmail(false)` still clears a stale error, so a
// visible message disappears as soon as the address becomes valid.
let emailTouched = false;

email.addEventListener('input', () => {
  email.value = email.value.replace(/^\s+/, '');
  validateEmail(emailTouched);
});

email.addEventListener('blur', () => {
  email.value = email.value.trim();
  emailTouched = true;
  validateEmail(true);
});
  mobile.addEventListener('input', () => validateMobile(true));
  country.addEventListener('change', () => validateCountry(true));
message.addEventListener('input', () => {
  message.value = message.value
    .replace(/^\s+/, '')       // remove leading spaces
    .replace(/\s{2,}/g, ' ');  // collapse multiple spaces

  validateMessage(true);
});



firstName.addEventListener('keydown', e => {
  const isLetter = /^[a-zA-Z]$/.test(e.key);
  const isSpace = e.key === ' ';
  const isControl =
    e.key === 'Backspace' ||
    e.key === 'Delete' ||
    e.key === 'ArrowLeft' ||
    e.key === 'ArrowRight' ||
    e.key === 'Tab';

  const pos = firstName.selectionStart;
  const prev = firstName.value[pos - 1];

  if (
    (!isLetter && !isSpace && !isControl && e.key.length === 1) ||
    (isSpace && (pos === 0 || prev === ' '))
  ) {
    e.preventDefault();
  }
});

lastName.addEventListener('keydown', e => {
  const isLetter = /^[a-zA-Z]$/.test(e.key);
  const isSpace = e.key === ' ';
  const isControl =
    e.key === 'Backspace' ||
    e.key === 'Delete' ||
    e.key === 'ArrowLeft' ||
    e.key === 'ArrowRight' ||
    e.key === 'Tab';

  const pos = lastName.selectionStart;
  const prev = lastName.value[pos - 1];

  if (
    (!isLetter && !isSpace && !isControl && e.key.length === 1) ||
    (isSpace && (pos === 0 || prev === ' '))
  ) {
    e.preventDefault();
  }
});
email.addEventListener('keydown', e => {
  if (e.key === ' ' && email.selectionStart === 0) {
    e.preventDefault();
  }
});







  /* ===============================
     Block ALL native submits
  =============================== */
  form.addEventListener('submit', (e) => {
    if (!validateForm(true)) {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  /* ===============================
     Manual submit via button
  =============================== */
  submitBtn.addEventListener('click', () => {
    // After a submit attempt the user has seen the errors, so keep email
    // feedback live while they correct it.
    emailTouched = true;
    if (!validateForm(true)) return;
    form.requestSubmit();
  });
});




document.addEventListener('DOMContentLoaded', () => {
  const newPwd     = document.querySelector('.wac-pwd-new');
  const confirmPwd = document.querySelector('.wac-pwd-confirm');
  const resetBtn   = document.querySelector('.wac-reset-page');

  if (!newPwd || !confirmPwd || !resetBtn) return;

  const PWD_ERROR_ID     = 'newPasswordError';
  const CONFIRM_ERROR_ID = 'confirmPasswordError';

  const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,40}$/;

  /* ===============================
     Helpers
  =============================== */
  function clearError(input, id) {
    const el = input.parentNode.querySelector(`#${id}`);
    if (el) el.remove();
  }

  function showError(input, id, msg) {
    clearError(input, id);
    const div = document.createElement('div');
    div.id = id;
    div.className = 'validation-error';
    div.textContent = msg;
    input.parentNode.appendChild(div);
  }

  /* ===============================
     New Password
  =============================== */
  function validateNewPassword(show) {
    const v = newPwd.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(newPwd, PWD_ERROR_ID, 'Password is required');
      valid = false;
    } else if (!PASSWORD_REGEX.test(v)) {
      if (show) showError(
        newPwd,
        PWD_ERROR_ID,
        'Use 8–40 chars with uppercase, lowercase, number & special character'
      );
      valid = false;
    } else {
      clearError(newPwd, PWD_ERROR_ID);
    }

    return valid;
  }

  /* ===============================
     Confirm Password
  =============================== */
  function validateConfirmPassword(show) {
    const v = confirmPwd.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(confirmPwd, CONFIRM_ERROR_ID, 'Please confirm password');
      valid = false;
    } else if (v !== newPwd.value.trim()) {
      if (show) showError(confirmPwd, CONFIRM_ERROR_ID, 'Passwords do not match');
      valid = false;
    } else {
      clearError(confirmPwd, CONFIRM_ERROR_ID);
    }

    return valid;
  }

  /* ===============================
     Live Validation
  =============================== */
  newPwd.addEventListener('input', () => {
    newPwd.value = newPwd.value.replace(/\s+/g, '');
    validateNewPassword(false);
    validateConfirmPassword(false);
  });

  confirmPwd.addEventListener('input', () => {
    confirmPwd.value = confirmPwd.value.replace(/\s+/g, '');
    validateConfirmPassword(false);
  });

  /* ===============================
     Manual Submit (ONLY when valid)
  =============================== */
  resetBtn.addEventListener('click', () => {
    let isValid = true;

    isValid = validateNewPassword(true) && isValid;
    isValid = validateConfirmPassword(true) && isValid;

    if (!isValid) return;

    const form = resetBtn.closest('form');
    if (form) form.requestSubmit();
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const loginPassword = document.querySelector('.wac-password-login');
  const loginButton   = document.querySelector('.login-button-standard');

  if (!loginPassword || !loginButton) return;

  const ERROR_ID = 'loginPasswordError';

  function clearError() {
    const el = loginPassword.parentNode.querySelector(`#${ERROR_ID}`);
    if (el) el.remove();
  }

  function showError(msg) {
    clearError();
    const div = document.createElement('div');
    div.id = ERROR_ID;
    div.className = 'validation-error';
    div.textContent = msg;
    loginPassword.parentNode.appendChild(div);
  }

  // remove error as soon as user types
  loginPassword.addEventListener('input', () => {
    if (loginPassword.value.trim()) {
      clearError();
    }
  });

  // validate on login button click
  loginButton.addEventListener('click', e => {
    if (!loginPassword.value.trim()) {
      e.preventDefault();
      showError('Password is required');
      loginPassword.focus();
    }
  });
});








document.addEventListener('DOMContentLoaded', () => {
  const submitButtons = document.querySelectorAll(
    '.account-entrance__button:not(.wac-reset-page), .addresses__button--add, .addresses__button--update'
  );
  if (!submitButtons.length) return;

  /* ===============================
     Error helpers
  =============================== */
  function clearError(input, id) {
    if (!input) return;
    const el = input.parentNode.querySelector(`#${id}`);
    if (el) el.remove();
  }

  function showError(input, id, msg) {
    if (!input) return;
    clearError(input, id);
    const div = document.createElement('div');
    div.id = id;
    div.className = 'validation-error';
    div.textContent = msg;
    input.parentNode.appendChild(div);
  }

  /* ===============================
     NAME
  =============================== */
  function bindName(input, id, label) {
    if (!input) return;

    input.addEventListener('keydown', e => {
      const isLetter = /^[a-zA-Z]$/.test(e.key);
      const isSpace = e.key === ' ';
      const pos = input.selectionStart;
      const prev = input.value[pos - 1];

      if (
        (!isLetter && !isSpace && e.key.length === 1) ||
        (isSpace && (pos === 0 || prev === ' '))
      ) {
        e.preventDefault();
      }
    });

    input.addEventListener('input', () => {
      input.value = input.value
        .replace(/[^a-zA-Z\s]/g, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/^\s+/, '');

      validateName(input, id, label, true);
    });
  }

  function validateName(input, id, label, show) {
    const v = input.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(input, id, `${label} is required`);
      valid = false;
    } else if (v.length < 3) {
      if (show) showError(input, id, 'Please enter at least 3 characters');
      valid = false;
    } else {
      clearError(input, id);
    }
    return valid;
  }

function validateLastNameRequired(input, show) {
  const v = input.value.trim();
  let valid = true;

  if (!v) {
    if (show) showError(input, 'lastNameError', 'Last name is required');
    valid = false;
  } else if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(v)) {
    if (show) showError(
      input,
      'lastNameError',
      'Last name must contain letters only'
    );
    valid = false;
  } else {
    clearError(input, 'lastNameError');
  }

  return valid;
}



  /* ===============================
     EMAIL
  =============================== */
  function bindEmail(input) {
    if (!input) return;

    input.addEventListener('input', () => {
      input.value = input.value
        .replace(/\s+/g, '')
        .replace(/[^a-zA-Z0-9.@_-]/g, '');

      validateEmail(input, true);
    });
  }

  function validateEmail(input, show) {
    if (!input) return true;
    const v = input.value.trim();
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let valid = true;

    if (!v) {
      if (show) showError(input, 'emailError', 'Email is required');
      valid = false;
    } else if (!re.test(v)) {
      if (show) showError(input, 'emailError', 'Please enter a valid email address');
      valid = false;
    } else {
      clearError(input, 'emailError');
    }
    return valid;
  }

  /* ===============================
     PASSWORD
  =============================== */
  function bindPassword(input) {
    if (!input) return;

    input.addEventListener('keydown', e => {
      if (e.key === ' ') e.preventDefault();
    });

    input.addEventListener('input', () => {
      input.value = input.value.replace(/\s+/g, '');
      validatePassword(input, true);
    });
  }

  function validatePassword(input, show) {
    if (!input) return true;
    const v = input.value;
    const re =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,40}$/;
    let valid = true;

    if (!v) {
      if (show) showError(input, 'passwordError', 'Password is required');
      valid = false;
    } else if (v.length < 8 || v.length > 40) {
      if (show) showError(input, 'passwordError', 'Password must be 8–40 characters');
      valid = false;
    } else if (!re.test(v)) {
      if (show) showError(
        input,
        'passwordError',
        'Include uppercase, lowercase, number, and special character'
      );
      valid = false;
    } else {
      clearError(input, 'passwordError');
    }
    return valid;
  }

  /* ===============================
     MOBILE
  =============================== */
  function bindMobile(input) {
    if (!input) return;

    input.addEventListener('input', () => {
      input.value = input.value
        .replace(/[^+\d]/g, '')
        .replace(/\+/g, (m, i) => (i === 0 ? m : ''));

      validateMobile(input, true);
    });
  }

  function validateMobile(input, show) {
    const value = input.value.trim();
    let valid = true;

    if (!value) {
      if (show) showError(input, 'mobileError', 'Mobile number is required');
      valid = false;
    } else {
      const match = value.match(/^\+?(\d+)$/);
      if (!match) {
        if (show) showError(input, 'mobileError', 'Only digits and a leading + are allowed');
        valid = false;
      } else {
        const digits = match[1];
        if (digits.length < 10 || digits.length > 11) {
          if (show) showError(input, 'mobileError', 'Mobile number must be 10 or 11 digits');
          valid = false;
        } else if (/^0+$/.test(digits) || /^1[0]+$/.test(digits)) {
          if (show) showError(input, 'mobileError', 'Please enter a valid phone number');
          valid = false;
        } else {
          clearError(input, 'mobileError');
        }
      }
    }
    return valid;
  }

  /* ===============================
     ADDRESS / CITY / ZIP
  =============================== */
  function bindSpaceSafe(input, validateFn) {
    if (!input) return;

    input.addEventListener('keydown', e => {
      const isAlphaNum = /^[a-zA-Z0-9]$/.test(e.key);
      const isSpace = e.key === ' ';
      const pos = input.selectionStart;
      const prev = input.value[pos - 1];

      if (
        (!isAlphaNum && !isSpace && e.key.length === 1) ||
        (isSpace && (pos === 0 || prev === ' '))
      ) {
        e.preventDefault();
      }
    });

    input.addEventListener('input', () => {
      input.value = input.value
        .replace(/[^a-zA-Z0-9\s]/g, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/^\s+/, '');

      validateFn(input, true);
    });
  }

  function validateAddress(input, show) {
    const v = input.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(input, 'addressError', 'Address is required');
      valid = false;
    } else if (v.length < 5) {
      if (show) showError(input, 'addressError', 'Address must be at least 5 characters');
      valid = false;
    } else if (!/^[a-zA-Z0-9][a-zA-Z0-9\s]*$/.test(v)) {
      if (show) showError(input, 'addressError', 'No special characters allowed');
      valid = false;
    } else {
      clearError(input, 'addressError');
    }
    return valid;
  }

  function validateCity(input, show) {
    const v = input.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(input, 'cityError', 'City is required');
      valid = false;
    } else if (!/^[a-zA-Z][a-zA-Z0-9\s]*$/.test(v)) {
      if (show) showError(input, 'cityError', 'City must start with a letter');
      valid = false;
    } else {
      clearError(input, 'cityError');
    }
    return valid;
  }

  function validateZipcode(input, show) {
    const v = input.value.trim();
    let valid = true;

    if (!v) {
      if (show) showError(input, 'zipcodeError', 'Zip code is required');
      valid = false;
    } else if (!/^[a-zA-Z0-9]+$/.test(v)) {
      if (show) showError(input, 'zipcodeError', 'Only letters and numbers allowed');
      valid = false;
    } else if (v.length < 4) {
      if (show) showError(input, 'zipcodeError', 'Zip code must be at least 4 characters');
      valid = false;
    } else {
      clearError(input, 'zipcodeError');
    }
    return valid;
  }

  /* ===============================
     COUNTRY (LIVE FIX)
  =============================== */
  function bindCountry(input) {
    if (!input) return;

    input.addEventListener('change', () => {
      validateCountry(input, true);
    });
  }

  function validateCountry(input, show) {
    let valid = true;
    if (!input.value || input.value === '---') {
      if (show) showError(input, 'countryError', 'Please select a valid country');
      valid = false;
    } else {
      clearError(input, 'countryError');
    }
    return valid;
  }

  /* ===============================
     Bind per form + submit
  =============================== */
  submitButtons.forEach(button => {
    const form = button.closest('form');
    if (!form) return;

    const firstName = form.querySelector('.wac-first-name');
    const lastName  = form.querySelector('.wac-last-name');
    const email     = form.querySelector('.wac-email');
    const password  = form.querySelector('.wac-password');
    const mobile    = form.querySelector('.wac-mobile');
    const address   = form.querySelector('.wac-address');
    const city      = form.querySelector('.wac-city');
    const country   = form.querySelector('.wac-country');
    const zipcode   = form.querySelector('.wac-zipcode');

    bindName(firstName, 'firstNameError', 'First name');
if (lastName) {
  lastName.addEventListener('keydown', e => {
    const isLetter = /^[a-zA-Z]$/.test(e.key);
    const isSpace  = e.key === ' ';
    const isControl =
      e.key === 'Backspace' ||
      e.key === 'Delete' ||
      e.key === 'ArrowLeft' ||
      e.key === 'ArrowRight' ||
      e.key === 'Tab';

    const pos = lastName.selectionStart;
    const prev = lastName.value[pos - 1];

    if (
      (!isLetter && !isSpace && !isControl) ||
      (isSpace && (pos === 0 || prev === ' '))
    ) {
      e.preventDefault();
    }
  });

  lastName.addEventListener('input', () => {
    lastName.value = lastName.value
      .replace(/[^a-zA-Z\s]/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/^\s+/, '');

    validateLastNameRequired(lastName, true);
  });

  lastName.addEventListener('blur', () => {
    lastName.value = lastName.value.trim();
    validateLastNameRequired(lastName, true);
  });
}


    bindEmail(email);
    bindPassword(password);
    bindMobile(mobile);
    bindSpaceSafe(address, validateAddress);
    bindSpaceSafe(city, validateCity);
    bindSpaceSafe(zipcode, validateZipcode);
    bindCountry(country);

    button.addEventListener('click', e => {
      e.preventDefault();

      let isValid = true;

      if (firstName) isValid = validateName(firstName, 'firstNameError', 'First name', true) && isValid;
if (lastName) isValid = validateLastNameRequired(lastName, true) && isValid;
      if (email)     isValid = validateEmail(email, true) && isValid;
      if (password)  isValid = validatePassword(password, true) && isValid;
      if (mobile)    isValid = validateMobile(mobile, true) && isValid;
      if (address)   isValid = validateAddress(address, true) && isValid;
      if (city)      isValid = validateCity(city, true) && isValid;
      if (country)   isValid = validateCountry(country, true) && isValid;
      if (zipcode)   isValid = validateZipcode(zipcode, true) && isValid;

      if (!isValid) return;

      form.requestSubmit();
    });
  });
});